import { PlainButton } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as FilterIcon } from "./assets/filter.svg";
import { ReactComponent as FilterActiveIcon } from "./assets/filter-active.svg";
import { ReactComponent as ClearIcon } from "./assets/clear.svg";

type FiltersButtonProps = {
  onClick: () => void;
  onClear: () => void;
  hasFilters: boolean;
};

export const FiltersButton = ({
  onClick,
  hasFilters,
  onClear,
}: FiltersButtonProps) => {
  const { t } = useTranslations();
  return (
    <PlainButton
      onClick={onClick}
      className="text-dark-800 hover:bg-grey-100 flex h-10 items-center gap-2 rounded-lg bg-white px-3 transition-colors"
    >
      {hasFilters ? <FilterActiveIcon /> : <FilterIcon />}
      {t({
        id: "invoices.filters.button",
        defaultMessage: "Filters",
      })}
      {hasFilters && (
        <div
          className="hover:bg-grey-300 bg-grey-200 h-5 w-5 rounded-full transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
        >
          <ClearIcon />
        </div>
      )}
    </PlainButton>
  );
};
